export const focusTargetId = (id: string) => {
  if (id?.length) {
    const targetElement = document.getElementById(id);
    targetElement?.focus();
    targetElement?.scrollIntoView();
  }
};
